import React from "react";
import styled from "styled-components";

export default styled.section`
    min-height: 77px;
    position: absolute;
    top: 0;
    left: 80px;
    right: 0;
    background: #d4edda;
    color: white;
    text-align: center;
    padding: 29px 10px;
    color: #155724;
    display: none;
    z-index: 9999999;

    ${(props) => (props.open ? {
    'display': 'block'
} : '')}

    ${(props) => (props.error ? {
    'background': '#f8d7da',
    'color': '#721c24'
} : '')}
`;